import React from 'react';
import { BsLink45Deg } from 'react-icons/bs';
import { motion } from 'framer-motion';

const ProjectsCard = ({ title, des, src, projectLink }) => {
  return (
    <motion.div
      whileHover={{ y: -10 }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
      className="w-full p-4 xl:px-12 h-auto xl:py-10 rounded-2xl shadow-shadowOne flex flex-col bg-gradient-to-r from-[#1e2024] to-[#202327] group hover:bg-[#000] border border-gray-800 hover:border-designColor transition-all duration-300 overflow-hidden relative"
    >
      {/* Glow Effect */}
      <div className="absolute inset-0 bg-designColor/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-xl"></div>

      <div className="w-full h-[80%] overflow-hidden rounded-lg z-10 relative">
        <a href={projectLink} target="_blank" rel="noopener noreferrer">
          <img
            className="w-full h-60 object-cover group-hover:scale-110 duration-500 cursor-pointer"
            src={src}
            alt={title}
          />
        </a>
      </div>
      <div className="w-full mt-5 flex flex-col gap-6 z-10 relative">
        <div>
          <div className="flex items-center justify-between">
            <h3 className="text-xl uppercase text-designColor font-bold font-titleFont hover:text-white transition-colors duration-300">
              <a href={projectLink} target="_blank" rel="noopener noreferrer">
                {title}
              </a>
            </h3>
            <div className="flex gap-2">
              <a
                href={projectLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor hover:shadow-neon duration-300 cursor-pointer"
              >
                <BsLink45Deg />
              </a>
            </div>
          </div>
          <p className="text-sm tracking-wide mt-3 text-gray-400 group-hover:text-gray-300 duration-300">
            {des}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectsCard;
